import React, { useEffect, useState } from "react";
import { Box, LinearProgress, Stack, Typography } from "@mui/material";

const STAGE_COLORS = {
  Pending: "#888780",
  Approved: "#7F77DD",
  Completed: "#1D9E75",
};

const ProductionPipeline = ({ rows }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setAnimate(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <Stack spacing={1.6}>
      {rows.map((row) => (
        <Box key={row.label}>
          <Stack direction="row" justifyContent="space-between" sx={{ fontSize: 12.5, color: "text.secondary", mb: 0.6 }}>
            <span>{row.label}</span>
            <Typography component="b" sx={{ color: "text.primary", fontWeight: 600, fontSize: 12.5 }}>
              {row.count}
            </Typography>
          </Stack>
          <LinearProgress
            variant="determinate"
            value={animate ? row.percent : 0}
            sx={{
              height: 8,
              borderRadius: 6,
              bgcolor: "#faf9f7",
              "& .MuiLinearProgress-bar": {
                bgcolor: STAGE_COLORS[row.label] || "#888780",
                borderRadius: 6,
                transition: "transform 900ms ease-out",
              },
            }}
          />
        </Box>
      ))}
    </Stack>
  );
};

export default ProductionPipeline;
